module.exports = "<div style=\"border: 1px solid red\">create-customer Component</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/customer-components/create-customer/create-customer.component.html
// module id = ./src/app/customer-components/create-customer/create-customer.component.html
// module chunks = main